module.exports = __webpack_public_path__ + "static/img/sas-new-icon-zh.b205ec7c.png";